
import { createRouter,createWebHistory } from "vue-router";


const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            redirect:'/login',
            //component: () => import('@/pages/LoginView.vue')
        },
        // {
        //     path: '/',
        //     component: () => import('@/pages/DashboardView.vue')
        // },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/pages/LoginView.vue')
        },
        {
            path: '/',
            //name: 'index',
            component: () => import('@/pages/IndexView.vue'),
            children:[
                {
                    path: 'dashboard',
                    component: () => import('@/pages/DashboardView.vue'),
                },
                {
                    path: 'monovalent',
                    component: () => import('@/pages/MonovalentView.vue'),
                },
                {
                    path: 'pay',
                    name: 'pay',
                    component: () => import('@/pages/PayView.vue'),
                },
                {
                    path: 'pay_success',
                    name: 'pay_success',
                    component: () => import('@/pages/PaySuccessView.vue'),
                },
                {
                    path: 'integral',
                    name: 'integral',
                    component: () => import('@/pages/IntegralView.vue'),
                },
                {
                    path: 'consumption',
                    name: 'consumption',
                    component: () => import('@/pages/ConsumptionView.vue'),
                },
                {
                    path: 'feedback',
                    name: 'feedback',
                    component: () => import('@/pages/FeedbackView.vue'),
                },
                {
                    path: 'questions',
                    name: 'questions',
                    component: () => import('@/pages/QuestionsView.vue'),
                },
                {
                    path: 'instructions',
                    name: 'instructions',
                    component: () => import('@/pages/InstructionsView.vue'),
                },
                {
                    path: 'tasks',
                    name: 'tasks',
                    component: () => import('@/pages/TaskView.vue'),
                },
            ]
        },

        {
            path: '/forget',
            name: 'forget',
            component: () => import('@/pages/UpdatePwdView.vue')
        },

    ],
})

export default router